import { useEffect, useRef, useState } from 'react'

interface LazyVideoProps {
	src: string
	poster: string
	className?: string
	children?: React.ReactNode
}

export function LazyVideo({
	src,
	poster,
	className,
	children,
}: LazyVideoProps) {
	const videoRef = useRef<HTMLVideoElement>(null)
	const [shouldLoad, setShouldLoad] = useState(false)

	useEffect(() => {
		const videoElement = videoRef.current
		if (!videoElement) return

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						setShouldLoad(true)
						observer.disconnect()
					}
				})
			},
			{
				rootMargin: '50px',
			},
		)

		observer.observe(videoElement)

		return () => {
			observer.disconnect()
		}
	}, [])

	return (
		<video
			ref={videoRef}
			src={shouldLoad ? src : undefined}
			poster={poster}
			controls
			preload="none"
			className={className}
		>
			{children}
		</video>
	)
}
